import { Col, Divider, Row } from 'antd';
import React from 'react';
import CustomInput from '../../../../../../../../components/CustomInput/CustomInput';
import FlexWrapper from '../../../../../../../../components/FlexWrapper/FlexWrapper';
import CustomSelect from '../../../../../../../../components/CustomSelect/CustomSelect';
import Spacer from '../../../../../../../../components/Spacer/Spacer';
import { Plus, Trash } from '../../../../../../../../components/Svg/Svg';
const selectOptions = [
    {
        id: 1,
        value: 'welcome_reminder_email_1',
        label: 'Welcome email reminder 1',
    },
    {
        id: 2,
        value: 'welcome_reminder_email_2',
        label: 'Welcome email reminder 2',
    },
    {
        id: 3,
        value: 'welcome_reminder_email_3',
        label: 'Welcome email reminder 3',
    },
    { id: 5, value: 'welcome_reminder_sms_1', label: 'Welcome sms reminder 1' },
    { id: 6, value: 'welcome_reminder_sms_2', label: 'Welcome sms reminder 2' },
    { id: 7, value: 'welcome_reminder_sms_3', label: 'Welcome sms reminder 3' },
    { id: 8, value: 'welcome_reminder_sms_4', label: 'Welcome sms reminder 4' },
];

export default function SpecificReminders({
    data,
    onInputChange,
    onSelectChange,
    onDeleteReminder,
    onAddReminder,
    onAddDay,
    onRemoveDay,
}) {
    return (
        <div>
            <div className="details-table-wrapper">
                <div className="table-top-pannel">
                    <div className="table-top-pannel__info">
                        <h2 className="table-top-pannel__title">
                            Welcome reminders
                        </h2>
                    </div>
                </div>
                {data?.timings?.map((timing, idx) => (
                    <div key={idx}>
                        <Row gutter={[48, 0]} key={idx}>
                            <Col span={12}>
                                <label
                                    className="input-label"
                                    style={{ marginBottom: '16px' }}
                                >
                                    Send out day
                                </label>
                                <CustomInput
                                    className="ant-input ant-input-lg"
                                    id="welcome_reminder_email_1"
                                    placeholder="Enter amount of days after registration"
                                    onInputChange={(e) => onInputChange(e, idx)}
                                    inputValue={data.timings[idx].day}
                                    width="100%"
                                />
                                <Spacer size={8} />
                                <button
                                    className="modal__button modal__button-cancel"
                                    type="button"
                                    style={{ width: 'auto' }}
                                    onClick={() => onRemoveDay(idx)}
                                    disabled={data?.timings?.length < 2}
                                >
                                    <FlexWrapper
                                        align="center"
                                        justify="center"
                                    >
                                        <Trash />
                                        &nbsp;&nbsp;Remove day
                                    </FlexWrapper>
                                </button>
                            </Col>
                            <Col span={12}>
                                <label
                                    className="input-label"
                                    style={{ marginBottom: '16px' }}
                                >
                                    Prio order
                                </label>
                                {timing.templatePriority.map((priority, i) => {
                                    const emailOpts = selectOptions.slice(0, 3);
                                    const smsOpts = selectOptions.slice(3);
                                    const opts =
                                        timing.templatePriority.length < 2
                                            ? selectOptions
                                            : (priority.id < 4 && emailOpts) ||
                                              smsOpts;
                                    return (
                                        <div key={i}>
                                            <FlexWrapper>
                                                <div style={{ flexGrow: 1 }}>
                                                    <CustomSelect
                                                        name="email"
                                                        onChange={(option) =>
                                                            onSelectChange(
                                                                option,
                                                                idx,
                                                                i,
                                                            )
                                                        }
                                                        options={opts}
                                                        placeholder="Select reminder"
                                                        value={priority.id}
                                                    />
                                                </div>
                                                {timing.templatePriority
                                                    .length > 1 ? (
                                                    <>
                                                        <Spacer
                                                            orientation="vertical"
                                                            size={8}
                                                        />
                                                        <FlexWrapper align="center">
                                                            <button
                                                                className="form__trash-button"
                                                                name="big-logo"
                                                                onClick={() =>
                                                                    onDeleteReminder(
                                                                        idx,
                                                                        i,
                                                                    )
                                                                }
                                                            >
                                                                <FlexWrapper
                                                                    align="center"
                                                                    justify="center"
                                                                >
                                                                    <Trash />
                                                                </FlexWrapper>
                                                            </button>
                                                        </FlexWrapper>
                                                    </>
                                                ) : timing.templatePriority
                                                      .length === 1 &&
                                                  i === 0 ? (
                                                    <div></div>
                                                ) : (
                                                    <div
                                                        style={{
                                                            width: '32px',
                                                            height: '32px',
                                                            marginLeft: '16px',
                                                        }}
                                                    ></div>
                                                )}
                                            </FlexWrapper>
                                            <Spacer size={8} />
                                        </div>
                                    );
                                })}
                                <button
                                    className="modal__button modal__button-cancel"
                                    style={{ width: '100%' }}
                                    onClick={() => onAddReminder(idx)}
                                    disabled={
                                        timing?.templatePriority?.length > 1
                                    }
                                >
                                    <FlexWrapper
                                        align="center"
                                        justify="center"
                                    >
                                        <Plus />
                                        &nbsp;&nbsp;Add reminder
                                    </FlexWrapper>
                                </button>
                            </Col>
                        </Row>
                        <Divider />
                    </div>
                ))}
                <FlexWrapper align="center" justify="center">
                    <button
                        className="modal__button modal__button-accept"
                        type="button"
                        onClick={onAddDay}
                        disabled={data?.timings?.length > 7}
                    >
                        <FlexWrapper align="center" justify="center">
                            <Plus />
                            &nbsp;&nbsp;Add day
                        </FlexWrapper>
                    </button>
                </FlexWrapper>
            </div>
        </div>
    );
}
